import { render, staticRenderFns } from "./ProductionEdition.vue?vue&type=template&id=72814bbc&"
import script from "./ProductionEdition.vue?vue&type=script&lang=js&"
export * from "./ProductionEdition.vue?vue&type=script&lang=js&"
import style0 from "./ProductionEdition.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports